<div class="RegisterReferral container mb-3" [formGroup]="formGroup" *ngIf="formGroup">
    <div class="row text-center">
        <h3>Referral Partner Details</h3>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="First Name" formControlName="name" placeholder="First Name"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="Email" formControlName="contact_email" placeholder="Email"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="Phone" formControlName="contact_phone" placeholder="Phone"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="Company Name" formControlName="company_name" placeholder="Company Name"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-select [items]="entityTypeOptions" label="Entity Type" formControlName="entity_type"></app-select>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="Signer Title" formControlName="signer_title" placeholder="Signer Title"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="Address Line 1" formControlName="address_line_1" placeholder="Street Address"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="City State Zip" formControlName="address_line_2" placeholder="City State Zip"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="ACH Bank Name" formControlName="ach_bank_name" placeholder="ACH Bank Name"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="ACH Bank Address" formControlName="ach_bank_address" placeholder="ACH Bank Address"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="ACH Account Holder Name" formControlName="ach_account_holder_name" placeholder="ACH Account Holder Name"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="ACH Account Number" formControlName="ach_account_number" placeholder="ACH Account Number"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-select [items]="accountTypeOptions" label="ACH Account Type" formControlName="ach_account_type"></app-select>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="Tax ID" formControlName="tax_id" placeholder="Tax ID"></app-text-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <app-text-field label="ACH Routing Number" formControlName="ach_routing_number" placeholder="ACH Routing Number"></app-text-field>
            <span class="text-muted font-small font-italic">ACH Routing Number is a 9 digit code, usually found at the bottom of your checks</span>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12">
            <span class="text-muted font-italic font-small">By clicking confirm, the creation of a Retreva Referral Partner account with the stated information will be completed.</span>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col col-12 text-center">
            <app-button
                [Click]='onSubmit'
                [color]="'orange'"
                [observeApi]='true'
                [size]="'medium'"
                [text]="'Confirm account'"
                class='RegisterReferral-button'></app-button>
        </div>
    </div>
</div>
